<div class="cockpit-page-container">
	<div class="header">
		<span class="title">COCKPIT</span>
		<!-- Componente do Header com filtros e notificações -->
		<div class="button-container">
			<pcp-filter-header (filterChange)="onFilterChange($event)"> </pcp-filter-header>
			<div class="button-wrapper">
				<span class="label-toggle">Exibir Valores</span>
				<cpi-toggle-switch [invertToggle]="false" [switchOn]="showChartValues" (switchOnChange)="toggleChartValues($event)">
				</cpi-toggle-switch>
			</div>
			<div class="button-wrapper" *ngIf="Router.url !== '/cockpit/full'">
				<span class="button-label">&nbsp;</span>
				<a class="button hide-on-small" target="_blank" [routerLink]="'/cockpit/full'">FULLSCREEN</a>
			</div>
			<div class="button-wrapper">
				<span class="button-label">&nbsp;</span>
				<a class="button" [routerLink]="'/cockpit/edit'">{{ labels.lbl_ckp_gerenciar_ckp }}</a>
			</div>
		</div>
	</div>

	<div
		class="empty-cockpit"
		*ngIf="
			(!cockpitCharts && !cockpitCards) ||
			(cockpitCharts.length === 0 && cockpitCards.length === 0 && !isLoadingCockpitCharts && !isLoadingCustomCockpitCharts)
		">
		<span>{{ labels.lbl_ckp_sem_indicadores_va_gerenciamento }}</span>
	</div>

	<div class="body" *ngIf="!isLoadingLabels && !isLoadingCockpitCharts && !isLoadingCustomCockpitCharts">
		<pcp-cockpit-chart
			[labels]="labels"
			[cockpitCards]="cockpitCards"
			[cockpitCharts]="cockpitCharts"
			[showChartValues]="showChartValues">
		</pcp-cockpit-chart>
		<br />
		<pcp-cockpit-chart
			[labels]="labels"
			[cockpitCards]="cockpitCustomCards"
			[cockpitCharts]="cockpitCustomCharts"
			[showChartValues]="showChartValues">
		</pcp-cockpit-chart>
	</div>

	<div class="loading-container" *ngIf="isLoadingLabels || (isLoadingCockpitCharts && isLoadingCustomCockpitCharts)">
		<cpi-svg-gears></cpi-svg-gears>
		<div>{{ labels.lbl_edocs_carregando }}!</div>
	</div>
</div>
